/* eslint-disable jsx-a11y/anchor-is-valid */
import {useNavigate} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
//components

//constants
import {reset} from '../../../../app/Redux/store'
import {
  getUserData,
} from '../../../../app/modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import {getAllUserDetails} from '../../../../app/pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import {useSocket} from '../../../../app/Utils/SocketProvider'
import {createFirstLetter} from '../../../../app/Utils/_helpers'

const HeaderUserOnboarding = () => {
  const socketID: any = useSocket()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const isAdminAsUser = localStorage.getItem('isAdminAsUser') ?? 'false'
  const isAdminAsStaff = localStorage.getItem('isAdminAsStaff') ?? 'false'
  const user = useSelector(getUserData)

  const data = useSelector(getAllUserDetails)

  const logoutFunc = () => {
    dispatch(reset())
    user?.user !== undefined ? navigate('/auth/login') : navigate('/auth/admin')
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-300px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            {data?.avatar == '' || data?.avatar == undefined || data?.avatar == 'undefined' ? (
              <span className='circle1'>{`${
                data?.firstName !== undefined && data?.firstName !== ''
                  ? data?.firstName?.split('')?.[0]?.toUpperCase() ?? 'C'
                  : createFirstLetter(data?.name)?.firstName ?? 'C'
              }${
                data?.lastName !== undefined && data?.lastName !== ''
                  ? data?.lastName?.split('')?.[0]?.toUpperCase() ?? 'C'
                  : createFirstLetter(data?.name).lastName ?? 'C'
              }`}</span>
            ) : (
              <img src={data?.avatar} alt='Cellcast' />
            )}
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-7'>{data?.name}</div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {data?.email}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>
      {isAdminAsUser === 'false' && isAdminAsStaff === 'false' && (
        <div className='menu-item px-5'>
          <a
            onClick={() => {
              socketID?.disconnect()
              logoutFunc()
            }}
            className='menu-link px-5'
          >
            Sign Out
          </a>
        </div>
      )}
    </div>
  )
}

export default HeaderUserOnboarding
